import {
    SET_KPI_LIST,
    SET_KPI_LIST_FILTER_DATA,
    SET_KPI_LIST_META,
    KPI_INIT_STATE,
    SET_KPI_LIST_BY_DATE,
    SET_KPI_LIST_BY_HOUR,
    SET_KPI_REPORTS_DATA,
    SET_KPI_STATISTICS,
} from "./types";

export const kpiReducer = (state = KPI_INIT_STATE, action) => {
    switch (action.type) {
        case SET_KPI_LIST:
            return {...state, kpiList: action.payload};
        case SET_KPI_LIST_META:
            return {...state, kpiListMeta: action.payload};
        case SET_KPI_LIST_BY_DATE:
            return {...state, kpiListByDate: action.payload};
        case SET_KPI_LIST_FILTER_DATA:
            return {...state, kpiListFilterData: action.payload};
        case SET_KPI_LIST_BY_HOUR:
            return {...state, kpiListByHour: action.payload};
        case SET_KPI_REPORTS_DATA:
            return {...state, kpiReportsData: action.payload};
        case SET_KPI_STATISTICS:
            return {...state, kpiStatistics: action.payload};
        default:
            return state
    }
}
